import type { Phase } from '../types';

/** Testing aid for dev and staging: jump to a moment of the fair. Not rendered in production builds. */
export function DemoBar({
  ph,
  offset,
  onChange,
}: {
  ph: Phase;
  offset: number | null;
  onChange: (offset: number | null) => void;
}) {
  if (!ph.valid) return null;
  const at = (ts: number) => () => onChange(ts - Date.now());
  const min = 60_000;
  const presets: [string, number][] = [
    ['לפני היריד', ph.cs - 90 * min],
    ['התכנסות', ph.cs + 10 * min],
    ['סבב 1', ph.R[0]!.start + 10 * min],
    ['הפסקה', ph.R[0]!.end + 2 * min],
    ['סבב 2', ph.R[1]!.start + 10 * min],
    ['סבב 3', ph.R[2]!.start + 10 * min],
    ['הסתיים', ph.R[2]!.end + 5 * min],
  ];
  return (
    <div className="demo-bar" role="region" aria-label="כלי בדיקה">
      <span className="demo-tag">בדיקות</span>
      {presets.map(([label, ts]) => (
        <button key={label} onClick={at(ts)}>
          {label}
        </button>
      ))}
      <button onClick={() => onChange(null)} aria-pressed={offset === null ? 'true' : 'false'}>
        שעון אמיתי
      </button>
    </div>
  );
}
